import { useState, useCallback } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Users } from 'lucide-react';
import GlobalHeader from '@/components/GlobalHeader';
import ContactsPlacesTabs from '@/components/contacts-places/ContactsPlacesTabs';
import ContactsTab from '@/components/contacts-places/ContactsTab';
import PlacesTab from '@/components/contacts-places/PlacesTab';
import ReimbursementsTab from '@/components/contacts-places/ReimbursementsTab';
import { toast } from 'sonner';
import APP_ICONS from '@/utils/appIcons';

const ContactsPlacesPage = () => {
  const [activeTab, setActiveTab] = useState('contacts');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = useCallback(async () => {
    setRefreshKey(prev => prev + 1);
    toast.success('Data refreshed');
  }, []);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'contacts':
        return <ContactsTab key={`contacts-${refreshKey}`} />;
      case 'places':
        return <PlacesTab key={`places-${refreshKey}`} />;
      case 'reimbursements':
        return <ReimbursementsTab key={`reimbursements-${refreshKey}`} />;
      default:
        return <ContactsTab key={`contacts-${refreshKey}`} />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-rose-50" data-testid="contacts-places-page">
      <GlobalHeader
        iconSrc={APP_ICONS.familyContacts}
        iconBgColor="#FCE7F3"
        iconColor="text-pink-700"
        title="Contacts & Places"
        subtitle="People, places, and receipts"
        onRefresh={handleRefresh}
      />

      <main className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8 pb-28">
        <Card className="shadow-sm border-pink-100 bg-white/80 backdrop-blur-sm">
          <CardContent className="p-3 sm:p-6">
            <ContactsPlacesTabs activeTab={activeTab} onTabChange={setActiveTab}>
              {renderTabContent()}
            </ContactsPlacesTabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default ContactsPlacesPage;
